import { Box } from "@mui/material";

import { ServiceFeedback } from "../../types/service.type";

import ServiceFeedbackCardLoader from "./ServiceFeedbackCardLoader";
import ServiceFeedbackCardHeader from "./ServiceFeedbackCardHeader";
import ServiceFeedbackCardBody from "./ServiceFeedbackCardBody";

const cardStyles = {
  container: (isFullWidth: boolean) => ({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: isFullWidth ? "100%" : "543px",
    maxWidth: "100%",
  }),
};

const ServiceFeedbackCard = ({
  feedback,
  isFullHeight = true,
  isFullWidth = false,
}: {
  feedback: ServiceFeedback;
  isFullHeight?: boolean;
  isFullWidth?: boolean;
}) => {
  return (
    <Box sx={cardStyles.container(isFullWidth)}>
      <ServiceFeedbackCardHeader feedback={feedback} />
      <ServiceFeedbackCardBody feedback={feedback} isFullHeight={isFullHeight} />
    </Box>
  );
};

export { ServiceFeedbackCard, ServiceFeedbackCardLoader };
